var map = {
	"./arg.svg": 2327,
	"./aus.svg": 2328,
	"./bel.svg": 2329,
	"./bra.svg": 2330,
	"./can.svg": 2331,
	"./cmr.svg": 2332,
	"./crc.svg": 2333,
	"./cro.svg": 2334,
	"./den.svg": 2335,
	"./ecu.svg": 2336,
	"./eng.svg": 2337,
	"./esp.svg": 2338,
	"./fra.svg": 2339,
	"./ger.svg": 2340,
	"./gha.svg": 2341,
	"./irn.svg": 2342,
	"./jpn.svg": 2343,
	"./kor.svg": 2344,
	"./ksa.svg": 2345,
	"./mar.svg": 2346,
	"./mex.svg": 2347,
	"./ned.svg": 2348,
	"./pol.svg": 2349,
	"./por.svg": 2350,
	"./qat.svg": 2351,
	"./sen.svg": 2352,
	"./srb.svg": 2353,
	"./sui.svg": 2354,
	"./tun.svg": 2355,
	"./uru.svg": 2356,
	"./usa.svg": 2357,
	"./wal.svg": 2358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;